module.exports = __webpack_public_path__ + "img/depmap_svg_V205.1da4c425.svg";